export const PackageReturnState = {
  ToScan: false,
  Completed: true,
};

export const getPackageStateName = (state) => {
  return (
    Object.keys(PackageReturnState).find(
      (key) => PackageReturnState[key] === state
    ) || null
  );
};
